<template>
  <v-container grid-list-xl class="pa-5">
    <v-row wrap>
      <v-col cols="12">
        <v-alert
          v-if="is_premium"
          dense text
          class="body-2 mb-5 pb-5"
          type="info"
        >
          Berikut ini merupakan daftar grup yang ada pada instansi Anda. Silakan
          <b>klik tombol tambah (+)</b> untuk menambah grup baru.
        </v-alert>
        <m-card-list
          two-line
          title="Grup"
          label-cari="Cari Grup"
          :add="isCan('group.store')"
          edit
          search
          :items="items"
          :headers="headers"
          refresh
          @refresh="load"
          :page="page"
          footer
          @search="
            search => {
              textSearch = search;
              load();
            }
          "
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
        >
          <template v-slot:items="{ props, item }">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td>
                <router-link
                  class="ok"
                  :to="{
                    name: 'grup.detail',
                    params: {
                      organisasi_id: organisasi_id,
                      group_id: item.group_id
                    }
                  }"
                  >{{ pVal(item, "nama") }}</router-link
                >
              </td>
              <td>{{ pVal(item, "keterangan") }}</td>
              <td>
                <m-menu
                  left
                  style="float:right"
                  :items="more_menu"
                  :object="item"
                />
              </td>
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  {{ headers[0].text }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  <router-link
                    class="ok"
                    :to="{
                      name: 'grup.detail',
                      params: {
                        organisasi_id: organisasi_id,
                        group_id: item.group_id
                      }
                    }"
                    >{{ pVal(item, "nama") }}</router-link
                  >
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  {{ headers[1].text }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, "keterangan") | toStr }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Aksi
                </div>
                <div class="v-data-table__mobile-row__cell">
                  <m-menu
                    left
                    style="float:right"
                    :items="more_menu"
                    :object="item"
                  />
                </div>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-col>
    </v-row>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Deskripsi", align: "left", value: "keterangan" },
        { text: "", sortable: false }
      ],
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] }
      },
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: () => isCan("group.update")
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: () => isCan("group.destroy")
        }
      ]
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("grup/get", {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch("grup/drop", {
            organisasi_id: this.organisasi_id,
            group_id: item.group_id
          })
        )
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
